"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlUserOnboarding = void 0;
const CommonUserOnboarding_1 = require("../../common/domain/CommonUserOnboarding");
const OnboardingId_1 = require("../../common/domain/OnboardingId");
const validator_1 = require("@leavy/validator");
const BaseUserOnboardingStep_1 = require("../../common/domain/BaseUserOnboardingStep");
const HlOnboardingStepId_1 = require("./HlOnboardingStepId");
const AccommodationDescriptionStep_1 = require("./description/AccommodationDescriptionStep");
const AccommodationPhotosStep_1 = require("./photos/AccommodationPhotosStep");
const InventoryStep_1 = require("./inventory/InventoryStep");
const infrastructure_1 = require("../../infrastructure");
const AdministrativeInfoStep_1 = require("./administrative/AdministrativeInfoStep");
const HlOnboardingDataTypeId_1 = require("./HlOnboardingDataTypeId");
const UpcomingDepartureStep_1 = require("./upcoming-departure/UpcomingDepartureStep");
const HlOnboardingStepTypes_1 = require("./HlOnboardingStepTypes");
const HlOnboardingExtraDataTypes_1 = require("./HlOnboardingExtraDataTypes");
const PaymentPreferencesStep_1 = require("./payment-preferences/PaymentPreferencesStep");
const PaymentPlanExtraData_1 = require("./payment-plan/PaymentPlanExtraData");
const UserOnboardingStatus_1 = require("../../common/domain/UserOnboardingStatus");
const AppointmentRequestStep_1 = require("./appointment-request/AppointmentRequestStep");
const HlUserOnboardingRejectionInfo_1 = require("./HlUserOnboardingRejectionInfo");
const RevenueEstimationStep_1 = require("./estimation/RevenueEstimationStep");
class HlUserOnboarding extends CommonUserOnboarding_1.CommonUserOnboarding {
    constructor(id, data) {
        super(id);
        this.initialize(data);
    }
    isRejected() {
        return super.isRejected();
    }
    get canSubmit() {
        if (this.status == UserOnboardingStatus_1.UserOnboardingStatus.STARTED) {
            return (this.revenueEstimation.isComplete()
                && this.upcomingDeparture.isComplete()
                && this.paymentPreferences.isComplete()
                && this.appointmentRequest.isComplete());
        }
        else if (this.status == UserOnboardingStatus_1.UserOnboardingStatus.SUBMITTED) {
            return this.steps.every(x => x.isComplete() || x.isOptional);
        }
        else {
            return false;
        }
    }
    get onboardingId() {
        return this.id[1];
    }
    get revenueEstimation() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_REVENUE_ESTIMATION, RevenueEstimationStep_1.RevenueEstimationStep);
    }
    get upcomingDeparture() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_UPCOMING_DEPARTURE, UpcomingDepartureStep_1.UpcomingDepartureStep);
    }
    get description() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_ACCOMMODATION_DESCRIPTION, AccommodationDescriptionStep_1.AccommodationDescriptionStep);
    }
    get photos() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_ACCOMMODATION_PHOTOS, AccommodationPhotosStep_1.AccommodationPhotosStep);
    }
    get inventory() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_INVENTORY, InventoryStep_1.InventoryStep);
    }
    get administrative() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_ADMINISTRATIVE_INFO, AdministrativeInfoStep_1.AdministrativeInfoStep);
    }
    get paymentPreferences() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_PAYMENT_PREFERENCES, PaymentPreferencesStep_1.PaymentPreferencesStep);
    }
    get appointmentRequest() {
        return this.getStep(HlOnboardingStepId_1.HlOnboardingStepId.HL_APPOINTMENT_REQUEST, AppointmentRequestStep_1.AppointmentRequestStep);
    }
    get paymentPlan() {
        return this.getExtraData(HlOnboardingDataTypeId_1.HlOnboardingDataTypeId.HL_PAYMENT_PLAN, PaymentPlanExtraData_1.PaymentPlanExtraData);
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => HlUserOnboardingRejectionInfo_1.HlUserOnboardingRejectionInfo),
    __metadata("design:type", HlUserOnboardingRejectionInfo_1.HlUserOnboardingRejectionInfo)
], HlUserOnboarding.prototype, "rejectionInfo", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingStep_1.BaseUserOnboardingStep, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: "stepId",
            subTypes: Object
                .entries(HlOnboardingStepTypes_1.HlOnboardingStepTypes)
                .map(([name, value]) => ({ name, value })),
        },
    }),
    __metadata("design:type", Array)
], HlUserOnboarding.prototype, "steps", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingStep_1.BaseUserOnboardingStep, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: "dataTypeId",
            subTypes: Object
                .entries(HlOnboardingExtraDataTypes_1.HlOnboardingExtraDataTypes)
                .map(([name, value]) => ({ name, value })),
        },
    }),
    __metadata("design:type", Array)
], HlUserOnboarding.prototype, "extraData", void 0);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "canSubmit", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "onboardingId", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", RevenueEstimationStep_1.RevenueEstimationStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "revenueEstimation", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", UpcomingDepartureStep_1.UpcomingDepartureStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "upcomingDeparture", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", AccommodationDescriptionStep_1.AccommodationDescriptionStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "description", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", AccommodationPhotosStep_1.AccommodationPhotosStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "photos", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", InventoryStep_1.InventoryStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "inventory", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", AdministrativeInfoStep_1.AdministrativeInfoStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "administrative", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", PaymentPreferencesStep_1.PaymentPreferencesStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "paymentPreferences", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", AppointmentRequestStep_1.AppointmentRequestStep),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "appointmentRequest", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", PaymentPlanExtraData_1.PaymentPlanExtraData),
    __metadata("design:paramtypes", [])
], HlUserOnboarding.prototype, "paymentPlan", null);
exports.HlUserOnboarding = HlUserOnboarding;
//# sourceMappingURL=HlUserOnboarding.js.map